import arbitrumConfig from './arbitrumConfig'
import bscConfig from './bscConfig'
import { ChainId, IChainConfig } from './chainCommon'
import ethereumConfig from './ethereumConfig'
import optimismConfig from './optimismConfig'
import polygonConfig from './polygonConfig'

const chainConfigs: Record<ChainId, IChainConfig> = {
  1: ethereumConfig,
  10: optimismConfig,
  56: bscConfig,
  137: polygonConfig,
  42161: arbitrumConfig,
}

export default chainConfigs
